import { Routes, Route, useLocation } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import ErrorBoundary from "designs/Common/ErrorBoundary";
import Footer from "designs/DesignB/components/Footer/Footer";
import Page404 from "designs/DesignB/containers/Page404/Page404";
import ListingCarPage from "designs/DesignB/containers/ListingCarPage/ListingCarPage";
import PageContact from "designs/DesignB/containers/PageContact/PageContact";
import PageAbout from "designs/DesignB/containers/PageAbout/PageAbout";
import SiteHeader from "designs/DesignA/containers/SiteHeader";
import AvailableCarsPage from "designs/DesignB/containers/AvailableCarsPage/AvailableCarsPage";
import PageHome from "designs/DesignB/containers/PageHome/PageHome";
import RentalPolicies from "designs/DesignB/components/RentalPolicies/RentalPolicies";
import {
  PrivacyPolicyPage,
  TermsAndConditionsPage,
} from "designs/Common/PolicyPage/PolicyPage";
import ListingCarDetailPage from "designs/Common/ListingDetailPage/listing-car-detail/ListingCarDetailPage";
import CarListingCarDetailPage from "designs/Common/CarListingDetailPage/CarListingDetailPage";
import CheckOutPagePageMain from "designs/Common/CheckOutPage/CheckOutPage";
import BookingDetailPage from "designs/Common/BookingDetailsPage/BookingDetailsPage";
import PaymentLinkRedirect from "designs/Common/PaymentLinkRedirect/PaymentLinkRedirect";
import PaymentSuccess from "designs/Common/PaymentSuccess/PaymentSuccess";
import PayLaterPoliciesPage from "designs/Common/PayLaterPoliciesPage/PayLaterPoliciesPage";

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/home", component: PageHome },
  { path: "/available-car", component: AvailableCarsPage },
  { path: "/vehicles", component: ListingCarPage },
  { path: "/booking-details", component: BookingDetailPage},
  { path: "/payment-success", component: PaymentSuccess },
  { path: "/listing-car-detail", component: ListingCarDetailPage },
  { path: "/checkout", component: CheckOutPagePageMain },
  { path: "/contact", component: PageContact },
  // About page — the Design B home "Learn more about us" CTA navigates here
  // (HomeAboutUs → /about). The route was missing, so /about hit the catch-all
  // 404 even though the page + the header-hide logic below already expected it
  // (1NOW-1252).
  { path: "/about", component: PageAbout },
  { path: "/car-listing-detail", component: CarListingCarDetailPage },
  { path: "/FAQ", component: RentalPolicies },
  // 1NOW-10372: publicly linkable legal pages, reachable from the footer on
  // every page and on the same two URLs Design A uses, so support can hand a
  // tenant one answer regardless of which design their site runs. The terms page
  // was at /rental-terms; that path was referenced by nothing (no code, and no
  // tenant nav menu on prod) so it was dropped rather than aliased.
  { path: "/terms-and-conditions", component: TermsAndConditionsPage },
  { path: "/privacy-policy", component: PrivacyPolicyPage },
  { path: "/pay-later-policies", component: PayLaterPoliciesPage },
];

const DesignARouter = () => {
  const location = useLocation(); // This will work now, because the component is within the BrowserRouter
  return (
    <>
      <ScrollToTop />
      {location.pathname !== "/" &&
        location.pathname !== "/about" &&
        location.pathname !== "/contact" && <SiteHeader />}

      {/* 1NOW-1642: header and footer stay outside the boundary so a failed
          page still leaves the renter a way to navigate. */}
      <ErrorBoundary name="design-b-routes">
        <Routes>
          {pages.map(({ component, path }) => {
            const Component = component;
            return <Route key={path} element={<Component />} path={path} />;
          })}
          {/* SMS payment short links: renter taps /pay/<slug>, we JS-redirect to Stripe/Square */}
          <Route path="/pay/:slug" element={<PaymentLinkRedirect />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default DesignARouter;
